import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '@app/shared/directives/directives.module';
import { DbmCircleProgressBarComponent } from '@app/shared/components/basic-components/dbm-circle-progress-bar/dbm-circle-progress-bar.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        MatProgressSpinnerModule
    ],
    declarations: [DbmCircleProgressBarComponent],
    exports: [
        DbmCircleProgressBarComponent, CommonModule
    ],
    entryComponents: [DbmCircleProgressBarComponent]
})
export class DbmCircleProgressBarModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-circle-progress-bar/dbm-circle-progress-bar.module.ts